import match from './match';

// ----------------------------------------------------------------------------

function matchExact(find: string, arr: string | readonly string[]): boolean {
    const normalizedValues = Array.isArray(arr) ? arr : [arr];

    for (const item of normalizedValues) {
        const escapedItem = escapeRegex(item);

        if (match(find, `^${escapedItem}$`)) {
            return true;
        }
    }

    return false;
}

// ----------------------------------------------------------------------------

function escapeRegex(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// ----------------------------------------------------------------------------

export default matchExact;
